// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fake-button-fake-button-1YTXyGjjmwr{cursor:pointer}@media(forced-colors: active){.fake-button-fake-button-1YTXyGjjmwr{color:ButtonText}.fake-button-fake-button-1YTXyGjjmwr:focus{outline:2px dotted ButtonText}}", "",{"version":3,"sources":["webpack://client/shared/fake-button/fake-button.scss"],"names":[],"mappings":"AAAA,qCACE,cAAA,CAEA,8BAHF,qCAII,gBAAA,CAEA,2CACE,6BAAA,CAAA","sourcesContent":[".fake-button {\n  cursor: pointer;\n\n  @media (forced-colors: active) {\n    color: ButtonText;\n\n    &:focus {\n      outline: 2px dotted ButtonText;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fake-button": "fake-button-fake-button-1YTXyGjjmwr",
	"fakeButton": "fake-button-fake-button-1YTXyGjjmwr"
};
export default ___CSS_LOADER_EXPORT___;
